<template>
  <div>
    <PageAllow controller="StockCurrents" action="view" />
    <Breadcrumbs :items="items" />
    <!-- 库存详情detail -->
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="6" md="4">
            <!-- 仓库中心 -->
            <SearcherStocks
              v-model="stocksSelected"
              :stock-district="stockDistrictSelected"
              :stock-types="[0]"
            />
          </v-col>
          <!-- 仓库分组 -->
          <v-col cols="12" sm="6" md="4">
            <SearcherStockDistrict v-model="stockDistrictSelected" />
          </v-col>
          <v-col cols="12" sm="6" md="4" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_details"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2 subtitle-2 accent--text">
                  {{
                    $t("Material.materialNameWithCode",
                      [
                        material.material_code,
                        material.material_name,
                      ]
                    )
                  }}
                  <br />
                  <span class="caption secondary--text">
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="material && material.standard_name && material.standard_name.length > 12" :title="material.standard_name" style="cursor: pointer">
                    {{ material.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ material ? material.standard_name : '' }}
                  </span>
                </span>
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </template>
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ stock_currents_total_num | formatTwoDot
                  }}{{ material.unit_order }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ stock_currents_total_price | formatMoney }}
                  </span>
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <!-- 库存数量 -->
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("CurrentStocksDetails.Fields.stock_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ stock_currents_total_num | formatTwoDot
                    }}{{ material.unit_order }}
                  </div>
                </td>
                <!-- 商品总金额 -->
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("CurrentStocksDetails.Fields.total_price") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ stock_currents_total_price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.stock_code="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{
                  $t("Stock.stockNameWithCode", [
                    item.stock_code,
                    item.stock_name,
                  ])
                }}
              </span>
            </template>
            <template v-slot:item.stock_district_name="{ item }">
              <span class="text-no-wrap">
                {{ item.stock_district_name }}
              </span>
            </template>
            <!-- 均价 -->
            <template v-slot:item.average="{ item }">
              {{ $t("Global.money")
              }}{{
                ((item.total_price / item.stock_total) * item.rate)
                  | formatMoney
              }}
            </template>
            <template v-slot:item.status="{ item }">
              <!-- 状态文字/颜色 -->
              <v-chip
                small
                label
                :color="item.status | currentStocksColor"
                :text-color="item.status | currentStocksTextColor"
              >
                {{ item.status | currentStocksText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                v-model="item.printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="info"
                    class="px-2"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentStocks.actions.details") }}
                    <v-icon x-small class="ps-1">
                      {{ item.printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="$permission.permissionAllow('StockDetails', 'index')"
                    :href="
                      '/#/stock-details?stock_ids=' +
                      item.stock_id +
                      '&stock_district_id=' +
                      item.stock_district_id +
                      '&material_id=' +
                      material.id
                    "
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.batch_details") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('StockOrderAnalyze', 'view')
                    "
                    :href="
                      '/#/stock-order-analyze/' +
                      item.material_id +
                      '?stock_id=' +
                      item.stock_id +
                      '&stock_district_id=' +
                      item.stock_district_id +
                      '&material_id=' +
                      material.id
                    "
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.in_out_details") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <!-- 格式化 -->
            <template v-slot:item.stock_max="{ item }">
              {{ item.stock_max | formatTwoDot }}
              <br v-if="locale" />
              <span :class="locale ? 'pt-n1 text-no-wrap caption' : ''">
                {{ item.unit }}
              </span>
              <!-- <span v-else>{{ item.unit }}</span> -->
            </template>
            <template v-slot:item.stock_min="{ item }">
              {{ item.stock_min | formatTwoDot }}
              <br v-if="locale" />
              <span :class="locale ? 'pt-n1 text-no-wrap caption' : ''">
                {{ item.unit }}
              </span>
              <!-- <span v-else>{{ item.unit }}</span> -->
            </template>
            <template v-slot:item.stock_total="{ item }">
              <span v-if="!locale">
                {{ item.stock_unit_num }}
              </span>
              <span v-else>
                {{ item.stock_single_unit_num }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_no_occupy_num="{ item }">
              <span v-if="!locale">
                {{ item.stock_no_occupy_num }}
              </span>
              <span v-else>
                {{ item.stock_single_no_occupy_num }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_occupy_num="{ item }">
              <span v-if="!locale">
                {{ item.stock_occupy_num }}
              </span>
              <span v-else>
                {{ item.stock_single_occupy_num }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.wait_shelve_num="{ item }">
              {{ item.wait_shelve_num | formatTwoDot }}{{ item.default_unit }}
            </template>
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatTwoDot }}
            </template>
            <template v-slot:item.batch_total_price="{ item }">
              {{ $t("Global.money")
              }}{{ item.batch_total_price | formatTwoDot }}
            </template>
            <!-- 状态 -->
            <template v-slot:item.status_flg="{ item }">
              <span
                v-if="
                  item.shortage == 0 &&
                  item.over_load == 0 &&
                  item.expire_status == 0
                "
              >
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'primary' : 'primary'"
                  text-color="white"
                >
                  {{ $t("CurrentStocksDetails.status.on") }}
                </v-chip>
              </span>
              <span v-if="item.shortage == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'danger' : 'danger'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off_min") }}
                </v-chip>
              </span>
              <span v-if="item.over_load == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'danger' : 'danger'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off_max") }}
                </v-chip>
              </span>
              <span v-if="item.expire_status == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'warning' : 'warning'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off") }}
                </v-chip>
              </span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import StockCurrents from "@/api/current_stocks";

const defaultOptions = {
  status: [0, 1],
  stock_ids: [],
  district_ids: null,
};

export default {
  data: () => ({
    stock_details: [],
    stockDistrictSelected: null,
    stocksSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stock_current_details-options")
        ? sessionStorage.getItem("stock_current_details-options")
        : JSON.stringify(defaultOptions)
    ),
    stock_currents_total_num: 0,
    stock_currents_total_price: 0,
    stock_currents_batch_total_price: 0,
    loading: false,
    material: {
      actions: {},
    },
  }),
  components: {
    Breadcrumbs,
    SearcherStocks,
    PageAllow,
    SearcherStockDistrict,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.currentStocks"),
          disabled: false,
          href: "/current-stocks",
        },
        {
          text: i18n.t("Nav.currentStocksDetails"),
          disabled: true,
        },
        {
          text:
            this.material && this.material.material_name
              ? this.material.material_name
              : "",
          disabled: false,
          accent: true,
        },
      ];
      return items;
    },
    headers: () => [
      {
        text: i18n.t("CurrentStocksDetails.Fields.stock"),
        align: "start",
        sortable: false,
        value: "stock_code",
      },
      // {
      //   text: i18n.t("CurrentStocksDetails.Fields.stock_name"),
      //   align: "start",
      //   sortable: false,
      //   value: "stock_name",
      // },
      {
        text: i18n.t("CurrentStocksDetails.Fields.stock_district_name"),
        align: "start",
        sortable: false,
        value: "stock_district_name",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.average"),
        align: "end",
        sortable: false,
        value: "average",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.stock_max"),
        align: "end",
        sortable: false,
        value: "stock_max",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.stock_min"),
        align: "end",
        sortable: false,
        value: "stock_min",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.stock_total"),
        align: "end",
        sortable: false,
        value: "stock_total",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.usable_stock_num"),
        align: "end",
        sortable: false,
        value: "stock_no_occupy_num",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.occupy_stock_num"),
        align: "end",
        sortable: false,
        value: "stock_occupy_num",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.status"),
        align: "start",
        sortable: false,
        value: "status_flg",
      },
      {
        text: i18n.t("CurrentStocksDetails.Fields.total_price"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    detailsParams() {
      if (this.options.district_ids && this.options.district_ids.length > 0)
        return "district_id=" + this.options.district_ids[0];
      else return "";
    },
    /* eslint-disable */
    stock_idsParams() {
      if (this.options.stock_ids && this.options.stock_ids.length > 0) {
        return "stock_ids=" + this.options.stock_ids;
      } else {
        return "";
      }
    },
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stock_current_details", [
        "stocksSelected",
        "stockDistrictSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "stockDistrictSelected":
                this.stockDistrictSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stocksSelected = [];
      this.stockDistrictSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getStockDetailsFromAPI() {
      this.loading = true;
      StockCurrents.fetchOne(this.$route.params.id, this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_details = response.data.stock_currents;
            this.material = response.data.material;
            this.stock_currents_total_num =
              response.data.stock_currents_total_num;
            this.stock_currents_total_price =
              response.data.stock_currents_total_price;
            this.stock_currents_batch_total_price =
              response.data.stock_currents_batch_total_price;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockDetailsFromAPI();
        sessionStorage.setItem(
          "stock_current_details-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_current_details-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 仓库组别搜索
    stockDistrictSelected: {
      handler() {
        this.options.district_ids = this.stockDistrictSelected
          ? [this.stockDistrictSelected.id]
          : [];
        sessionStorage.setItem(
          "stock_current_details-stockDistrictSelected",
          JSON.stringify(this.stockDistrictSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>